import { DocumentCollaborationParameter } from "./DocumentCollaborationParameter";

/**
 * 現状の雑多な引数もこのクラス経由で渡すようにしたい
 */
export class DocumentParameterContainer {
  public collaborationParameter: DocumentCollaborationParameter;
}
